import React from 'react';
import Select from 'react-select';

import RGROUPS from '../../resources/political-constants';

function getOptions(totalText) {
  const rgroups = Object.assign({}, RGROUPS);
  if (totalText) {
    rgroups.GLOBAL.verbose = totalText;
  }
  return Object.keys(rgroups).map(regionalGroupKey => ({
    value: regionalGroupKey,
    label: rgroups[regionalGroupKey].verbose
  }));
}

const RegionalGroupSelect = props => (
  <div style={{ position: 'relative' }}>
    <span
      style={{ position: 'absolute', top: 0, left: 0 }}
      className="glyphicon glyphicon-globe"
    />
    <Select
      name="regional-group-selector"
      value={props.value}
      options={getOptions(props.textForTotal)}
      onChange={props.onChange}
      searchable={false}
      clearable={false}
      placeholder="Select a group / region"
      className={props.className}
    />
  </div>
);

export default RegionalGroupSelect;



// WEBPACK FOOTER //
// ./src/components/Selects/RegionalGroup.js